import restapi from 'shared-module/api/restapi'

const requestHdVideo = (cameraId, photoId) => restapi.post(`/api/v3/photo/video/${cameraId}/${photoId}`, { quality: 'hd' })

const clearHdVideo = (cameraId, photoId) => restapi.get(`/api/v3/photo/video/${cameraId}/${photoId}`)

const videoDownloadApi = { requestHdVideo: requestHdVideo, clearHdVideo: clearHdVideo }
export default videoDownloadApi
